import { render, staticRenderFns } from "./Lyrics.vue?vue&type=template&id=176d17e0&scoped=true&"
import script from "./Lyrics.vue?vue&type=script&lang=js&"
export * from "./Lyrics.vue?vue&type=script&lang=js&"
import style0 from "./Lyrics.vue?vue&type=style&index=0&id=176d17e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176d17e0",
  null
  
)

export default component.exports